import { registerQuery } from 'data-fetching-client';
import { getCurrencyRequestRpc, getPublicCurrencyResponseRpc } from 'growth-monetization-service-types';
import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getEarlyRequestResult } from '../utils/earlyRequest';
import { getCurrencyStoreResponse } from './dataTransformer';

// ******************* Public ***********************
const rpcClientNoAuth = createRpcClientV2({
  hubHttpClient: noAuthHttp
});
export const GET_PUBLIC_CURRENCIES = registerQuery({
  fieldName: 'currencies',
  args: ['earlyRequestName', 'preferredCountryCode', 'browserLocale'],
  fetcher({
    earlyRequestName,
    browserLocale,
    preferredCountryCode
  }) {
    return getEarlyRequestResult(earlyRequestName, () => rpcClientNoAuth.call(getPublicCurrencyResponseRpc, {
      pathParameters: {
        browserLocale
      },
      queryParameters: {
        preferredCountryCode
      }
    })).then(response => {
      const currencyStoreResponse = getCurrencyStoreResponse(response);
      return currencyStoreResponse;
    });
  }
});

// ******************* In-App ***********************
const rpcClientAuth = createRpcClientV2({
  hubHttpClient: http
});
export const GET_IN_APP_CURRENCIES = registerQuery({
  fieldName: 'currencies',
  args: ['earlyRequestName'],
  fetcher({
    earlyRequestName
  }) {
    return getEarlyRequestResult(earlyRequestName, () => rpcClientAuth.call(getCurrencyRequestRpc, {})).then(response => {
      const currencyStoreResponse = getCurrencyStoreResponse(response);
      return currencyStoreResponse;
    });
  }
});

// ******************* Upgrade Page in PPUI Request ***********************
/**
 * @temporary used to support the version of the Upgrade Page App that lives in PPUI
 * This should be removed once the upgrade page has been extracted from PPUI
 * @expiration 2025-05-09
 * @deprecated
 */
export const GET_CURRENCIES = registerQuery({
  fieldName: 'currencies',
  args: ['earlyRequestName'],
  fetcher({
    earlyRequestName
  }) {
    return getEarlyRequestResult(earlyRequestName, () => rpcClientAuth.call(getCurrencyRequestRpc, {}));
  }
});